import validate from "/home/dario/data/sorgente/portaleFornitori/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "/home/dario/data/sorgente/portaleFornitori/middleware/01.auth.global.ts";
import _02_45get_45necessary_45data_45global from "/home/dario/data/sorgente/portaleFornitori/middleware/02.getNecessaryData.global.ts";
import _03_45redirect_45home_45global from "/home/dario/data/sorgente/portaleFornitori/middleware/03.redirectHome.global.ts";
import manifest_45route_45rule from "/home/dario/data/sorgente/portaleFornitori/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  _02_45get_45necessary_45data_45global,
  _03_45redirect_45home_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}